import 'assets/css/modal.css';
import 'styles/custom.css';
import * as React from 'react';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { purgeCCTokens, getRegionNames, getTenantOrSPHostUrl } from "../components/Requests/Requests";
import {
  StandardScreen,
  StandardDropdown, 
  StandardTextField, 
  StandardButton, 
  StatusMessage,
  PageLayout,
  StandardText,
  TextFieldWithTooltip,
  DropdownWithTooltip
} from '../components/Layout';
import theme from '../styles/theme.js';

const inputTypeDropdownOptions = [
    { key: 'sphosturl', text: 'SPHostUrl' },
    { key: 'tenantID', text: 'Tenant ID' }
];

const allEnvironments = [
    { key: 'production', text: 'Production' },
    { key: 'preprod', text: 'Preprod' },
    { key: 'test', text: 'Test' },
    { key: 'preview', text: 'Preview' },
    { key: 'dev', text: 'Dev' }
];

const iManageTypes = [
    { key: 'cloud', text: 'Cloud' },
    { key: 'work', text: 'Work' }
];

class CCActions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            regionNameChosen: "",
            tokenTypeChosen: "",
            tenantId: "",
            userId: "",
            libraryName: "",
            error: "",
            message: "",
            loading: false,
            loadingPurge: false,
            loadingCheck: false,
            regionNames: "",
            queryValue: "",
            regionNameChosenSP: "",
            inputTypeChosen: "",
            searchPerformed: false,
            queryResults: [],
            messageSP: "",
            errorSP: "",
            allRegionNames: "",
        }
    }

    componentDidMount() {
        this.initializeSettings();
    }

    initializeSettings() {
        this.getRegionNames(true);
        this.getAllRegionNames();
    }

    async getRegionNames(onlyWithCCKeyVaultUrl) {
        try {
            let response = await getRegionNames(this.props.accessToken, onlyWithCCKeyVaultUrl)
            if (response.ok) {
                const dataArray = await response.json();
                this.setState({ regionNames: dataArray.map(item => { return { key: item, text: item } }) });
            } else {
                this.setState({ error: "Error: Environment details cannot be retrieved", message: "" });
            }
        } catch (error) {
            console.log("Error fetching region names:", error);
            this.setState({ error: "Error: Environment details cannot be retrieved", message: "" });
        }
    }

    async getAllRegionNames() {
        this.setState({ loading: true })
        let response = await getRegionNames(this.props.accessToken);
        if (response.status === 200) {
            let data = await response.json();
            this.setState({
                loading: false,
                allRegionNames: data.map(item =>
                    ({ key: item, text: item })),
            });
        } else {
            this.setState({ loading: false, error: "Something went wrong", message: "" });
        };
    }

    onSelectTokenType = (event, item) => {
        this.setState({ tokenTypeChosen: item.key });
    };

    onSelectRegionName = (event, item) => {
        this.setState({ regionNameChosen: item.key });
    };

    onSelectRegionNameSP = (event, item) => {
        this.setState({ regionNameChosenSP: item.key });
    };

    onSelectIManageEnvironment = (event, item) => {
        this.setState({ iManageEnvironment: item.key });
    };

    onSelectIManageType = (event, item) => {
        this.setState({ iManageType: item.key });
    };

    onSelectInputType = (event, item) => {
        this.setState({ inputTypeChosen: item.key, mappedQueryResults: [], searchPerformed: false });
    };

    onTenantIdChange = (event, newValue) => {
        this.setState({ 
            tenantId: newValue,
            error: "",
            message: ""
        });
    };

    onSPHostUrlChange = (event, newValue) => {
        this.setState({ 
            spHostUrl: newValue,
            error: "",
            message: ""
        });
    };

    onUserIdChange = (event, newValue) => {
        this.setState({ 
            userId: newValue,
            error: "",
            message: ""
        });
    };

    onLibraryNameChange = (event, newValue) => {
        this.setState({ 
            libraryName: newValue,
            error: "",
            message: ""
        });
    };

    onQueryValueChange = (event, newValue) => {
        this.setState({ 
            queryValue: newValue,
            errorSP: "",
            messageSP: "",
            queryResults: [],
            searchPerformed: false
        });
    };

    async purgeCCTokens(requestBody) {
        this.setState({ loadingPurge: true });
        try {
            const response = await purgeCCTokens(this.props.accessToken, requestBody);
            const responseData = await response.json();
            if (response.ok) {
                this.setState({ message: responseData.message, error: "", loadingPurge: false });
            } else {
                this.setState({
                    error: responseData.Message || responseData.message || "Error when purging token",
                    message: "",
                    loadingPurge: false,
                });
            }
        } catch (error) {
            this.setState({ error: "An unexpected error occurred", message: "", loadingPurge: false });
        }
    }

    constructAndSendRequest() {
        let requestBody = {
            RegionName: this.state.regionNameChosen,
            TokenType: this.state.tokenTypeChosen,
            UserId: this.state.userId,
            TenantId: this.state.tenantId,
            LibraryName: this.state.tokenTypeChosen === 'IManage' ? this.state.libraryName : "",
            SPHostUrl: this.state.spHostUrl,
            Environment: this.state.iManageEnvironment,
            IManageType: this.state.iManageType
        };
        this.purgeCCTokens(requestBody);
    }

    isFormValid() {
        const { regionNameChosen, tokenTypeChosen, tenantId, userId } = this.state;

        if (!regionNameChosen || !tokenTypeChosen || !tenantId || !userId) {
            return false;
        }

        return true;
    }

    async getTenantOrSPHostUrl() {
        this.setState({ loadingCheck: true, errorSP: "", messageSP: "" })
        let requestBody = {};
        requestBody = {
            QueryValue: this.state.queryValue,
            RegionName: this.state.regionNameChosenSP,
            InputType: this.state.inputTypeChosen
        };
        let response = await getTenantOrSPHostUrl(this.props.accessToken, requestBody);
        let data = await response.json();
        if (response.status === 200) {
            // Check if data is an array, otherwise treat it as a single value
            const results = Array.isArray(data) ? data : [data];
            this.setState({ loadingCheck: false, queryResults: results, searchPerformed: true })
        } else {
            this.setState({ loadingCheck: false, errorSP: "Something went wrong", queryResults: [], searchPerformed: true });
        }
    }

    render() {
        const {
            loading,
            loadingPurge,
            loadingCheck,
            error,
            message,
            errorSP,
            messageSP,
            regionNameChosen,
            tokenTypeChosen,
            tenantId,
            userId,
            libraryName,
            regionNames,
            regionNameChosenSP,
            inputTypeChosen,
            queryValue,
            allRegionNames,
            searchPerformed,
            queryResults,
            spHostUrl,
            iManageType,
            iManageEnvironment,
        } = this.state;

        return (
            <PageLayout>
                <StandardScreen
                    title="Purge Customer Tokens"
                    description="Purge tokens for a specific customer."
                    loading={loading}
                >
                    <StandardDropdown
                        label="Environment"
                        selectedKey={regionNameChosen}
                        onChange={this.onSelectRegionName}
                        placeholder="Select Environment"
                        options={regionNames}
                        disabled={!regionNames || regionNames.length === 0}
                    />

                    <StandardDropdown
                        label="Token Type"
                        selectedKey={tokenTypeChosen}
                        onChange={this.onSelectTokenType}
                        placeholder="Select Token Type"
                        options={[
                            { key: 'SharePoint', text: 'SharePoint' },
                            { key: 'NetDocuments', text: 'NetDocuments' },
                            { key: 'IManage', text: 'iManage' }
                        ]}
                    />

                    <div style={{ display: 'flex', gap: '20px' }}>
                        <StandardTextField
                            label="Tenant ID"
                            placeholder="Tenant ID"
                            value={tenantId}
                            onChange={this.onTenantIdChange}
                        />

                        {tokenTypeChosen === 'IManage' && (
                            <StandardTextField
                                label="SPHostUrl"
                                placeholder="SPHostUrl"
                                value={spHostUrl}
                                onChange={this.onSPHostUrlChange}
                            />
                        )}

                        {tokenTypeChosen === 'IManage' && (
                            <StandardDropdown
                                label="IManage Type"
                                selectedKey={iManageType}
                                onChange={this.onSelectIManageType}
                                placeholder="Select iManage Type"
                                options={iManageTypes}
                            />
                        )}
                    </div>

                    <div style={{ display: 'flex', gap: '20px' }}>
                        <StandardTextField
                            label="User ID"
                            placeholder="User ID"
                            value={userId}
                            onChange={this.onUserIdChange}
                        />

                        {tokenTypeChosen === 'IManage' && (
                            <TextFieldWithTooltip
                                label="Library Name"
                                placeholder="Library Name"
                                value={libraryName}
                                onChange={this.onLibraryNameChange}
                                tooltipContent={
                                    <StandardText
                                        color={theme.colors.primary}
                                        variant='small'
                                    >
                                        Note: Use the name taken from the iManage library mappings page in ICP, not the URL
                                    </StandardText>
                                }
                            />
                        )}

                        {tokenTypeChosen === 'IManage' && (
                            <DropdownWithTooltip
                                label="CC Environment"
                                selectedKey={iManageEnvironment}
                                onChange={this.onSelectIManageEnvironment}
                                placeholder="Select CC Environment"
                                options={allEnvironments}
                                tooltipContent={
                                    <StandardText
                                        color={theme.colors.primary}
                                        variant='small'
                                    >
                                        The CC environment name (appears in the token name)
                                    </StandardText>
                                }
                            />
                        )}
                    </div>

                    <StandardButton
                        text="Reset"
                        onClick={() => this.constructAndSendRequest()}
                        disabled={loadingPurge || !this.isFormValid()}
                        style={{ marginRight: '10px' }}
                    />
                    {loadingPurge && (
                        <Spinner size={SpinnerSize.small} label="Processing..." />
                    )}


                    {error && (
                        <StatusMessage type="error">{error}</StatusMessage>
                    )}

                    {message && (
                        <StatusMessage type="success">{message}</StatusMessage>
                    )}
                </StandardScreen>

                <StandardScreen
                    title="TenantID / SPHostUrl Lookup"
                    description="Get the TenantID associated with a SPHostUrl or vice versa."
                    loading={loading}
                >
                    <StandardDropdown
                        label="Environment"
                        selectedKey={regionNameChosenSP}
                        onChange={this.onSelectRegionNameSP}
                        placeholder="Select Environment"
                        options={allRegionNames}
                    />

                    <StandardDropdown
                        label="Input Type"
                        selectedKey={inputTypeChosen}
                        onChange={this.onSelectInputType}
                        placeholder="Select Input Type"
                        options={inputTypeDropdownOptions}
                    />

                    <StandardTextField
                        label="Tenant ID / SPHostUrl"
                        placeholder="Tenant ID / SPHostUrl"
                        value={queryValue}
                        onChange={this.onQueryValueChange}
                    />

                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                        <StandardButton
                            text="Search"
                            onClick={() => this.getTenantOrSPHostUrl()}
                            disabled={!queryValue || !inputTypeChosen || !regionNameChosenSP}
                            style={{ marginRight: '10px' }}
                        />
                        {loadingCheck && (
                            <Spinner size={SpinnerSize.small} label="Searching..." />
                        )}
                    </div>

                    {errorSP && (
                        <StatusMessage type="error">{errorSP}</StatusMessage>
                    )}

                    {messageSP && (
                        <StatusMessage type="success">{messageSP}</StatusMessage>
                    )}

                    {searchPerformed && (
                        <div style={{ marginTop: '20px', marginLeft: '20px' }}>
                            {queryResults && queryResults.length > 0 ? (
                                <div>
                                    <StatusMessage>
                                        <strong>Item(s) associated with input value:</strong>
                                        <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
                                            {queryResults.map((result, index) => (
                                                <li key={index} style={{ marginBottom: '5px' }}>
                                                    {result}
                                                </li>
                                            ))}
                                        </ul>
                                    </StatusMessage>
                                </div>
                            ) : (
                                <StatusMessage type="warning">
                                    <strong>No results found.</strong>
                                </StatusMessage>
                            )}
                        </div>
                    )}
                </StandardScreen>
            </PageLayout>
        );
    }
}

export default CCActions;
